import { render, staticRenderFns } from "./BookWindow.vue?vue&type=template&id=86ace7fc&scoped=true&"
import script from "./BookWindow.vue?vue&type=script&lang=js&"
export * from "./BookWindow.vue?vue&type=script&lang=js&"
import style0 from "./BookWindow.vue?vue&type=style&index=0&id=86ace7fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ace7fc",
  null
  
)

export default component.exports